<template>
  <v-row dense :justify="justify">
    <v-btn
      :small="small"
      :color="color"
      @click="playVideo()"
      depressed
      rounded
      class="rounded"
    >
      <v-icon left> {{ icon }} </v-icon>
      {{ name || $t("common.watchTheVideo") }}
    </v-btn>

    <v-dialog v-model="play" width="70%">
      <v-card>
        <v-card-title class="text-h5">
          <v-btn icon @click="play = false" border>
            <v-icon>ph-x</v-icon>
          </v-btn>
          {{ title }}
        </v-card-title>

        <v-card-text>
          <iframe
            v-if="play"
            width="100%"
            height="600"
            :src="`https://www.youtube-nocookie.com/embed/${id_youtube_video}?controls=0&amp;start=0&autoplay=1&rel=0&showinfo=0&fs=0&iv_load_policy=3`"
            title="YouTube video player"
            frameborder="0"
            allow="autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "playVideoButton",
  props: {
    name: { type: String },
    color: { type: String, default: "grey lighten-5" },
    icon: { type: String, default: "ph-fill ph-youtube-logo" },
    id_youtube_video: {
      type: String,
      default: "cr7o8C8yd2s",
    },
    title: { type: String, default: "" },
    justify: { type: String, default: "center" },
    small: { type: Boolean, default: false },
  },
  data() {
    return {
      play: false,
    };
  },
  methods: {
    playVideo() {
      this.play = true;
    },
  },
};
</script>

<style></style>
